import { FooterData, TaxNumber } from '../../../app/data/model';
import Link from '../../../app/shared/components/Link';
import LogoLink from '../LogoLink/LogoLink';
import css from './SiteFooter.css';

const currentYear = new Date().getFullYear();

interface SiteFooterProps extends Pick<FooterData, 'brand' | 'copyright' | 'groupAddress' | 'links' | 'tagline'> {
  homeUrl: string;
  taxNumber: TaxNumber;
  contactEmail?: string;
  localAddress?: string;
  storeDisplayName?: string;
}

export default function SiteFooter({
  brand,
  contactEmail,
  copyright,
  homeUrl,
  groupAddress,
  links,
  localAddress,
  storeDisplayName,
  tagline,
  taxNumber,
}: SiteFooterProps) {
  return (
    <footer className={css.root}>
      <div className={css.container}>
        <div className={css.header}>
          <LogoLink href={homeUrl} size="large" variant="light" />
          {(brand || tagline) && (
            <p className={css.subtitle}>
              {brand && <span className={css.brand}>{brand}</span>}
              {brand && tagline && <span className={css.separator}>|</span>}
              {tagline && <span className={css.tagline}>{tagline}</span>}
            </p>
          )}
        </div>
        {(contactEmail || localAddress || taxNumber?.value) && (
          <div className={css.storeDetails}>
            {localAddress && (
              <p className={css.localAddress}>
                <span className={css.storeName}>Flokk {storeDisplayName}</span>
                {localAddress}
              </p>
            )}
            {contactEmail && (
              <a className={css.link} href={`mailto:${contactEmail}`}>
                {contactEmail}
              </a>
            )}
            {taxNumber?.value && (
              <p className={css.taxNumber}>
                {taxNumber.name} {taxNumber.value}
              </p>
            )}
          </div>
        )}
        {links.length > 0 && (
          <ul className={css.linkList}>
            {links.map((item) => (
              <li key={item.code}>
                <Link className={css.link} href={item.url} target={item.target}>
                  {item.name}
                </Link>
              </li>
            ))}
          </ul>
        )}
        <div className={css.bottom}>
          <p className={css.copyright}>
            {copyright.copyrightNoticeText} {currentYear} Flokk {copyright.allRightsReservedText}
          </p>
          {groupAddress && (
            <p className={css.groupAddress}>
              {groupAddress.label && <span>{groupAddress.label}</span>}
              {groupAddress.address && <span>{groupAddress.address}</span>}
              {groupAddress.country && <span>{groupAddress.country}</span>}
            </p>
          )}
        </div>
      </div>
    </footer>
  );
}
